<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div
    class="input-field"
    :class="{ 'input-field--inline': labelPosition === 'inline' }"
  >
    <label
      v-if="label"
      :for="inputId"
      class="input-field__label"
    >{{ label }}</label>
    <div class="input-field__wrapper">
      <i
        v-if="iconLeft"
        :class="iconLeft"
        class="input-field__icon"
      />
      <app-input
        :id="inputId"
        v-model="proxyValue"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
      />
      <i
        v-if="iconRight"
        :class="iconRight"
        class="input-field__icon"
      />
    </div>
  </div>
</template>

<script>
/**
 * InputField — поле ввода с опциональными иконками и лейблом.
 *
 * @example Минимальный вариант
 * <input-field v-model="value" placeholder="Введите текст" />
 *
 * @example С иконкой слева и лейблом сверху (по умолчанию)
 * <input-field v-model="name" label="ФИО" icon-left="exu-person" />
 *
 * @example Лейбл в одну строку с полем, иконки с обеих сторон
 * <input-field
 *   v-model="search"
 *   label="Поиск"
 *   label-position="inline"
 *   icon-left="exu-search-1"
 *   icon-right="exu-close"
 * />
 */
import { AppInput } from '@/components/atoms';

export default {
  name: 'InputField',
  components: { AppInput },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    /** Тип поля: text, email, password, tel, number и т.д. */
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    /** 'top' — лейбл над полем, 'inline' — лейбл в одну строку с полем */
    labelPosition: {
      type: String,
      default: 'top',
      validator: (v) => ['top', 'inline'].includes(v),
    },
    /** CSS-класс иконки шрифта, например 'exu-person' */
    iconLeft: {
      type: String,
      default: '',
    },
    /** CSS-класс иконки шрифта, например 'exu-close' */
    iconRight: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    inputId() {
      return `input-field-${this.$.uid}`;
    },
    proxyValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<style lang="scss">
.input-field {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;

  &--inline {
    flex-direction: row;
    align-items: center;
    gap: 12px;

    .input-field__label {
      flex-shrink: 0;
      white-space: nowrap;
    }

    .input-field__wrapper {
      flex: 1;
    }
  }

  &__label {
    font-size: 14px;
    color: #6b7280;
  }

  &__wrapper {
    display: flex;
    align-items: center;
    height: 48px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 0 12px;
    gap: 8px;
  }

  &__icon {
    flex-shrink: 0;
    font-size: 20px;
    color: #9E9E9E;
  }
}
</style>
